import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
} from '@angular/core';
import {
  DeepLinkStatus,
  DisneyPlusStatus,
  getPriceForTrialOption,
  InternetProduct,
  isActiveTrialOption,
  isAsOrAsasOption,
  isDisneyPlusActive,
  isDisneyPlusNotActive,
  MobileProduct,
  NetflixBuyAndSellStatus,
  OptionStatus,
  PlcCodes,
  TvProduct,
} from '@dch/products-business-logic';
import {
  AnalyticsService,
  CustomerService,
  EnvironmentService,
  InceptionService,
  LanguageService,
  TranslationService,
} from '@proximus/ng-common';
import {
  Alert,
  AlertsService,
  ModalService,
  PxModalMessageService,
} from '@proximus/ng-common-components';
import { OptionDetailsBaseComponent } from '../option-details-base/option-details-base.component';
import { Location } from '@angular/common';
import { Store } from '@ngrx/store';
import {
  ApplicationState,
  getDisneyPlusToken,
  getDisneyPlusTokenError,
} from '../../../store/reducers';
import { getPiiServiceId } from '../../../shared/pii/pii.utils';
import { OptionDetailsBackgroundService } from './option-details-background.service';
import { GetDisneyWebToken } from '../../../store/actions/disney-plus-account-management.actions';

@Component({
  selector: 'mprd-option-details-background',
  templateUrl: './option-details-background.component.html',
})
export class OptionDetailsBackgroundComponent
  extends OptionDetailsBaseComponent
  implements OnInit, OnChanges, OnDestroy
{
  serviceId: string;
  OptionStatus = OptionStatus;
  DeepLinkStatus = DeepLinkStatus;

  @Input()
  option: any;
  @Input()
  isStartingFromPriceVisible: boolean;
  @Input()
  isFreeAsteriksVisible: boolean;
  @Input()
  selectedProduct: MobileProduct | InternetProduct | TvProduct;
  @Input()
  isDeepLinkDataLoaded: boolean;
  @Input()
  deepLinkStatus: DeepLinkStatus;
  @Input()
  isDeepLinkFootNoteVisible: boolean;
  @Input()
  isDeepLinkMultipleProductsEligible: boolean;
  @Input()
  isDiscountTextVisible: boolean;
  @Input()
  flexPackDiscountText: string;
  @Input()
  isOnTopCurrentPackVisible: boolean;
  @Input()
  netflixBuyAndSellStatus: NetflixBuyAndSellStatus;
  @Input()
  treatmentCode: string;
  @Input()
  isRes: boolean;
  @Input()
  productType: string;
  @Input()
  queryParamToken: string;

  PlcCodes = PlcCodes;
  showCeaseButton: boolean;
  NetflixBuyAndSellStatus = NetflixBuyAndSellStatus;
  isDisneyPlusProduct: boolean;
  isSportsProduct: boolean;
  isPickXDisneyPlusProduct: boolean;
  disneyPlusUrl: string;

  priceTrialOption: string;
  isActiveTrialOption: boolean;

  originalBodyClass: string;

  isLoadingToken = false;
  disneyOptionStatus: DisneyPlusStatus;

  isPromotionalSectionVisible = false;
  isASorASAS = false;
  isPromoPrice = false;
  isFeatureFlag: boolean;
  isSportsFeatureFlag: boolean;
  promoPrice: number;
  promoPriceNumber: string;
  promoPriceDecimal: string;
  promoPriceDuration: string;
  language: string;

  constructor(
    languageService: LanguageService,
    alertService: AlertsService,
    translationService: TranslationService,
    private inceptionService: InceptionService,
    private element: ElementRef,
    private cdRef: ChangeDetectorRef,
    customerService: CustomerService,
    location: Location,
    modalService: ModalService,
    pxModalMessageService: PxModalMessageService,
    analyticsService: AnalyticsService,
    private store: Store<ApplicationState>,
    environmentService: EnvironmentService,
    private optionDetailsBackgroundService: OptionDetailsBackgroundService,
  ) {
    super(
      translationService,
      languageService,
      alertService,
      customerService,
      location,
      modalService,
      pxModalMessageService,
      analyticsService,
      environmentService,
    );
    // adapt the page header to negative colors of TV option details page
    const el = document.querySelector('.rs-header2020');
    if (el) {
      el.className = 'rs-header2020 rs-header-neg';
    }
    const elTlc = document.querySelector('.rs-header-tlc');
    if (elTlc) {
      elTlc.setAttribute('style', 'display: none');
    }
    const elBody = document.querySelector('body');
    if (elBody) {
      this.originalBodyClass = elBody.className;
      elBody.className = elBody.className + ' rs-bg-black';
    }
  }

  ngOnInit() {
    this.language = this.languageService.getSelectedLanguage();
    this.isFeatureFlag =
      (this.translationService.getTranslatedValueFor('tv.isFeatureFlag') ??
        'false') === 'true';
    this.isSportsFeatureFlag =
      (this.translationService.getTranslatedValueFor(
        'tv.isSportsFeatureFlag',
      ) ?? 'false') === 'true';
   

    this.serviceId = getPiiServiceId();
    this.disneyOptionStatus = this.getDisneyOptionStatus();
    this.addSubscription(
      this.store.select(getDisneyPlusToken).subscribe((value) => {
        if (value && value.token && this.isLoadingToken) {
          this.disneyPlusUrl = this.translationService
            .getTranslatedValueFor(
              'tv.active.options.disneyplus.button.activate.link',
            )
            .replace('{0}', value.token);
          this.goToDisneyPlusActivationPage();
          this.isLoadingToken = false;
        }
      }),
    );

    this.addSubscription(
      this.store.select(getDisneyPlusTokenError).subscribe((error) => {
        if (error) {
          const alert: Alert = {
            isClosable: true,
            alertKey: 'disneyPlusActivationAlert',
            title: this.translationService.getTranslatedValueFor(
              'tv.active.options.disneyplus.error.title',
            ),
            description: this.translationService.getTranslatedValueFor(
              'tv.active.options.disneyplus.error.description',
            ),
            type: 'error',
            useNegativeColors: true,
          };
          this.alertService.dispatchAlert(alert);
          this.isLoadingToken = false;
        }
      }),
    );

    this.isPromotionalSectionVisible =
      this.translationService.getTranslatedValueFor(
        'tv.options.promo.isPromotionalSectionVisible',
      ) === 'true';
    this.isASorASAS = isAsOrAsasOption(this.option);
    this.initPromoPrice();
  }

  ngOnChanges() {
    if (this.option && this.option.backgroundImage) {
      this.element.nativeElement.firstChild.firstChild.setAttribute(
        'data-interchange',
        '[' +
          this.option.backgroundImage.small +
          ', (default)],[' +
          this.option.backgroundImage.medium +
          ', (medium)],[' +
          this.option.backgroundImage.large +
          ', (large)]',
      );
    }
    this.hasWebdeals();
    this.getWebdealSuffix();
    this.setOptionName();
    this.setOptionDescriptionName();

    setTimeout(() => {
      this.inceptionService.init();
    }, 1000);

    this.priceTrialOption = getPriceForTrialOption(
      this.option,
      this.isRes,
    ).toString();
    this.isActiveTrialOption = isActiveTrialOption(this.option);
    this.disneyOptionStatus = this.getDisneyOptionStatus();

    this.optionDetailsBackgroundService.registerOptionParams({
      option: this.option,
      selectedProduct: this.selectedProduct,
      isDeepLink: this.isDeepLinkDataLoaded,
      deepLinkStatus: this.deepLinkStatus,
      treatmentCode: this.treatmentCode,
      queryParamToken: this.queryParamToken,
    });

    this.isDisneyPlusProduct =
      this.optionDetailsBackgroundService.isDisneyPlusProduct();
    this.isSportsProduct =
      this.optionDetailsBackgroundService.isSportsProduct();
    this.isPickXDisneyPlusProduct =
      this.optionDetailsBackgroundService.isPickXDisneyPlusProduct();
  }

  isOptionIncluded(includedOption: boolean) {
    this.showCeaseButton = !includedOption;
    this.cdRef.detectChanges();
  }

  private goToDisneyPlusActivationPage() {
    // MPRD-9534 : Safari does not allow opening new tab from async action
    // As a workaround, we open the disney link in the same tab for Safari users.
    // MPRD-9555 : Chrome browser contains Safari in its user agent so we need to check that Chrome is not set along with Safari.
    const isChrome = navigator.userAgent.indexOf('Chrome') > -1;
    const isSafari = !isChrome && navigator.userAgent.indexOf('Safari') > -1;
    window.open(this.disneyPlusUrl, isSafari ? '_top' : '_blank');
  }

  getDisneyOptionStatus() {
    if (!this.isSmoothAccess) {
      if (this.option && isDisneyPlusNotActive(this.option))
        return DisneyPlusStatus.NOT_ACTIVE;
      else if (this.option && isDisneyPlusActive(this.option))
        return DisneyPlusStatus.ACTIVE;
    } else {
      if (
        this.option &&
        this.option.disneyBSStatus === DisneyPlusStatus.NOT_ACTIVE
      )
        return DisneyPlusStatus.NOT_ACTIVE;
      else if (
        this.option &&
        this.option.disneyBSStatus === DisneyPlusStatus.ACTIVE
      )
        return DisneyPlusStatus.ACTIVE;
    }
    return DisneyPlusStatus.NOT_ELIGIBLE;
  }

  isDisneyOptionActivable() {
    if (this.disneyOptionStatus === DisneyPlusStatus.NOT_ACTIVE) return true;
    else return false;
  }

  isDisneyOptionActive() {
    if (this.disneyOptionStatus === DisneyPlusStatus.ACTIVE) return true;
    else return false;
  }

  initPromoPrice() {
    this.isPromoPrice = this.option?.customPrices?.promoPrices?.length > 0;
    if (this.isPromoPrice) {
      this.promoPrice = this.isRes
        ? this.option?.customPrices?.promoPrices[0].priceVat
        : this.option?.customPrices?.promoPrices[0].priceNoVat;
      const splitedPrice = this.promoPrice.toString().split('.');
      this.promoPriceNumber = splitedPrice[0];
      this.promoPriceDecimal = splitedPrice[1];
      this.promoPriceDuration =
        this.option?.customPrices?.promoPrices[0].promoDuration[
          this.languageService.getSelectedLanguage()
        ];
      this.isOptionIncluded(false);
    }
  }

  public getDisneyPlusToken() {
    this.isLoadingToken = true;
    this.store.dispatch(
      new GetDisneyWebToken({
        serviceId: this.serviceId,
        token: this.queryParamToken,
      }),
    );
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    // put back normal header
    const el = document.querySelector('.rs-header2020');
    if (el) {
      el.className = 'rs-header2020';
    }
    const elTlc = document.querySelector('.rs-header-tlc');
    if (elTlc) {
      elTlc.removeAttribute('style');
    }
    const elBody = document.querySelector('body');
    if (elBody) {
      elBody.className = this.originalBodyClass;
    }
  }
}
